import React from 'react'
import Routes from '@/components/routes/Routes'
import { ThemeProvider } from '@mui/material/styles'
import mainTheme from '@/components/themes/mainTheme'
import { SnackbarUtilsConfigurator } from '@/components/snackbarUtils/SnackbarUtils'
import { BrowserRouter } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { SnackbarProvider } from 'notistack'
import './i18n'
import store from './store'

const App: React.FC = () => {
  const loader = document.getElementById('loader')
  loader.classList.add('loaded')

  setTimeout(() => {
    loader.remove()
  }, 1000)

  return (
    <>
      <ReduxProvider store={store}>
        <SnackbarProvider>
          <SnackbarUtilsConfigurator />
          <React.StrictMode>
            <BrowserRouter>
              <React.Suspense fallback={<></>}>
                <ThemeProvider theme={mainTheme}>
                  <Routes />
                </ThemeProvider>
              </React.Suspense>
            </BrowserRouter>
          </React.StrictMode>
        </SnackbarProvider>
      </ReduxProvider>
    </>
  )
}

export default App
